import { Component, OnInit } from '@angular/core';

//jquery declaration
declare var $: any;
@Component({
  selector: 'app-nsprogram',
  templateUrl: './nsprogram.component.html',
  styleUrls: ['./nsprogram.component.css']
})
export class NsprogramComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    this.topposition();
  }

  //scroll to top of the page automatically
  topposition() { 
    $('html, body').animate({
      scrollTop: 0
    }, 1000, 'easeInOutExpo');

    return false;
}

}
